import {
    BILLING_CYCLES,
    TIERS,
    TIER_PRICES,
    YEARLY_TOTALS,
} from "../../constants/membership";

const TIER_RANK = {
    [TIERS.FREE]: 0,
    [TIERS.PREMIUM]: 1,
    [TIERS.PRO]: 2,
};

export function getCurrentTier(membership) {
    return TIER_RANK[membership?.tier] == null
        ? TIERS.FREE
        : membership.tier;
}

export function isFounderRateAvailable(founderProgress) {
    return Boolean(
        founderProgress?.enabled === true &&
        Number(founderProgress?.discountPercent) > 0 &&
        (founderProgress?.spotsAvailable || founderProgress?.userIsFounder),
    );
}

export function getPlanPricing({ tier, billingCycle, founderProgress }) {
    const isYearly = billingCycle === BILLING_CYCLES.YEARLY;
    const regularMonthlyAmount = Number(
        TIER_PRICES[tier]?.[billingCycle] || 0,
    );
    const regularYearlyTotal = Number(YEARLY_TOTALS[tier] || 0);
    const founderApplied = Boolean(
        tier === TIERS.PRO &&
        isYearly &&
        isFounderRateAvailable(founderProgress),
    );
    const founderDiscountPercent = founderApplied
        ? Number(founderProgress.discountPercent)
        : 0;
    const yearlyTotal = founderApplied
        ? Math.round(
              regularYearlyTotal * (1 - founderDiscountPercent / 100) * 100,
          ) / 100
        : regularYearlyTotal;
    const monthlyAmount = founderApplied
        ? Math.round((yearlyTotal / 12) * 100) / 100
        : regularMonthlyAmount;
    const savingsPercent = TIER_PRICES[tier]?.monthly
        ? Math.round(
              ((TIER_PRICES[tier].monthly - TIER_PRICES[tier].yearly) /
                  TIER_PRICES[tier].monthly) *
                  100,
          )
        : 0;

    return {
        founderApplied,
        founderDiscountPercent,
        monthlyAmount,
        regularMonthlyAmount,
        regularYearlyTotal,
        savingsPercent,
        yearlyTotal,
    };
}

export function getPlanAction({
    currentTier,
    planTier,
    billingCycle,
    currentBillingCycle,
    yearlyRenewalEligible = false,
}) {
    if (currentTier === planTier) {
        const canRenew =
            billingCycle === BILLING_CYCLES.YEARLY &&
            currentBillingCycle === BILLING_CYCLES.YEARLY &&
            yearlyRenewalEligible;

        return canRenew
            ? { kind: "renew", label: `Renew ${planTier}` }
            : { kind: "current", label: "Current plan" };
    }

    if ((TIER_RANK[currentTier] || 0) > (TIER_RANK[planTier] || 0)) {
        return { kind: "included", label: "Included with Pro" };
    }

    const planName = planTier === TIERS.PRO ? "Pro" : "Premium";
    return { kind: "upgrade", label: `Upgrade to ${planName}` };
}
